export default __webpack_public_path__ + "1b2b8c5.png";